import React, { useEffect, useRef, useState } from 'react';
// import Modal from 'react-modal';
import './search-web-modal.scss';
// import closeIcon from '../../../../images/close_icon.svg';
import placeHolder1 from '../../../../images/beach.jpg';
import Slider from 'react-slick';
import { useDispatch, useSelector } from 'react-redux';
import { GetTreatmentsDetails } from '../../../redux/actions/treatmentList/getTreatmentsDetails';
import StepButton from '../../../common/StepButton';
// import TreatmentDetailsSkeleton from '../../../clininc-cart-skeleton/TreatmentDetailsSkeleton';
// import TreatmentDescriptionRenderer from './TreatmentDesc';
import { CLEAR_BOOKING_LINK_TREATMENT_DETAILS } from '../../../redux/constants/treatment-list-const/TreatmentListConst';
import CustomModal from '../../../modal/CustomModal';
import { AppText, AppTitle } from '../../../common/typography/app-text';
import VerticalStack from '../../../common/wrapper/VerticalStack';
import { pounds } from '../../../../utils/general';
import { ReactComponent as StarIcon } from '../../../../images/icons/bl-star-icon.svg';
import { ReactComponent as TimeIcon } from '../../../../images/icons/bl-time-icon.svg';
import { ReactComponent as LeftArrow } from '../../../../images/calander_previous.svg';
import { ReactComponent as RightArrow } from '../../../../images/calander_next.svg';
import { toastV2 } from '../../../common/CustomToast/toastV2';
import Skeleton from 'react-loading-skeleton';
import { NoStyleButton } from '../../../common/icon-button/IconButton';
import { formatTime } from '../helper';

const SkeletonComponent = () => {
    return (
        <>
            <div>
                <Skeleton height={295} borderRadius={8} />
            </div>
            <div>
                <Skeleton height={54} borderRadius={8} />
            </div>
            <div>
                <Skeleton height={48} borderRadius={100} />
            </div>
        </>
    );
};

const TreatmentDetailsPopup = ({
    isOpen,
    setIsOpen,
    treatmentDetails,
    isAdded,
    treatmentDataToBeOPenInModal,
    setSelectedTreatment,
}) => {
    const dispatch = useDispatch();
    const sliderRef = useRef(null); // Ref to control slider
    const [currentSlide, setCurrentSlide] = useState(0);

    const treatmentDetailsData = useSelector(
        (state) => state.treatmentsDetailReducer?.treatementDetail?.treatment_details
    );

    const { initGetTreatmentDetailsForUser, userTreatmentDetailsQueryData } =
        GetTreatmentsDetails();
    const sliderData = [placeHolder1];

    useEffect(() => {
        if (isOpen) {
            initGetTreatmentDetailsForUser({
                slug: treatmentDetails?.slug,
                // slug: '',
                getTreatmentDetailsId: treatmentDetails?.treatmentId,
                isNeedDefaultImage: true,
            });
        }
    }, [isOpen]);

    const settings1 = {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: false,
        arrows: false,
        afterChange: setCurrentSlide,
    };

    const handlePrev = () => {
        if (sliderRef.current) {
            sliderRef.current.slickPrev();
        }
    };
    const handleNext = () => {
        if (sliderRef.current) {
            sliderRef.current.slickNext();
        }
    };

    const clearTreatmentDetails = () => {
        setTimeout(() => {
            dispatch({ type: CLEAR_BOOKING_LINK_TREATMENT_DETAILS });
        }, 300);
    };

    return (
        <CustomModal
            portalClassName="treatmentDetailsPreviewPopup__wrapper"
            modalOpen={isOpen}
            setModalOpen={() => {
                setIsOpen(false);
                setCurrentSlide(0);
                clearTreatmentDetails();
            }}
            className="treatmentDetailsPreviewPopup"
            modaltitle={
                userTreatmentDetailsQueryData?.loading ? (
                    <Skeleton height={45} width={280} />
                ) : (
                    <AppTitle font="xl">{treatmentDetailsData?.treatment_name}</AppTitle>
                )
            }
            modalBody={
                <VerticalStack className="treatmentDetailsPreviewPopup__body">
                    {userTreatmentDetailsQueryData?.loading ? (
                        <SkeletonComponent />
                    ) : (
                        <>
                            <div className="slider-web-container">
                                {treatmentDetailsData?.treatment_images?.length > 1 && (
                                    <NoStyleButton
                                        className="slider-arrow left"
                                        onClick={handlePrev}
                                        disabled={currentSlide === 0}
                                    >
                                        <LeftArrow />
                                    </NoStyleButton>
                                )}
                                <Slider ref={sliderRef} {...settings1}>
                                    {treatmentDetailsData?.treatment_images?.length === 0
                                        ? sliderData.map((item) => (
                                              <div className="sliderImgWrapper">
                                                  <img src={item} alt="item" />
                                              </div>
                                          ))
                                        : treatmentDetailsData?.treatment_images?.map((item) => (
                                              <div className="sliderImgWrapper">
                                                  <img src={item?.image_url} alt="item" />
                                              </div>
                                          ))}
                                </Slider>
                                {treatmentDetailsData?.treatment_images?.length > 1 && (
                                    <NoStyleButton
                                        className="slider-arrow right"
                                        onClick={handleNext}
                                        disabled={
                                            currentSlide ===
                                            (treatmentDetailsData?.treatment_images?.length || 1) -
                                                1
                                        }
                                    >
                                        <RightArrow />
                                    </NoStyleButton>
                                )}
                            </div>
                            <div>
                                <VerticalStack space={12}>
                                    
                                    <div className="treatmentDetailsPreviewPopup__reviewSection">
                                        <AppTitle>
                                            Price:{' '}
                                            {pounds.format(treatmentDetailsData?.treatment_price || 0)}
                                        </AppTitle>
                                        <div
                                            className="treatmentDetailsPreviewPopup__reviewItem"
                                        >
                                            <StarIcon style={{ transform: 'translateY(-1px)' }} />
                                            <AppText style={{ lineHeight: 1 }} dark>
                                                {
                                                    treatmentDataToBeOPenInModal?.average_review_rating
                                                }{' '}
                                                ({treatmentDataToBeOPenInModal?.total_review_count})
                                            </AppText>
                                        </div>
                                        <div className="treatmentDetailsPreviewPopup__reviewItem">
                                            <TimeIcon />
                                            <AppText style={{ lineHeight: 1 }} dark>
                                                {formatTime(
                                                    treatmentDetailsData?.treatment_duration || 0
                                                )}
                                            </AppText>
                                        </div>
                                    </div>
                                    <AppText className="treatmentDetailsPreviewPopup__descriptionText">
                                        {treatmentDetailsData?.treatment_description}
                                    </AppText>
                                </VerticalStack>
                            </div>
                            <StepButton
                                onClick={() => {
                                    if (!isAdded) {
                                        setSelectedTreatment((prevSelectedTreatments) => {
                                            return [
                                                ...prevSelectedTreatments,
                                                treatmentDataToBeOPenInModal,
                                            ];
                                        });
                                        toastV2('Treatment added');
                                    } else {
                                        setSelectedTreatment((prevSelectedTreatments) => {
                                            return prevSelectedTreatments.filter(
                                                (t) => t.id !== treatmentDataToBeOPenInModal.id
                                            );
                                        });
                                    }
                                    setCurrentSlide(0);
                                    setIsOpen(false);
                                    clearTreatmentDetails();
                                }}
                                label={isAdded ? 'Remove' : 'Add to booking'}
                                blue={!isAdded}
                                gray={isAdded}
                            />
                        </>
                    )}
                </VerticalStack>
            }
        />
    );
};

export default TreatmentDetailsPopup;
